import React from "react";
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const AlertMessage = ({ brand, show }) => {

  let email = (brand == 'TB') ? 'orders@testbase.co.uk' : 'orders@exampro.co.uk';

  if (show == true) {
    return (
      <Container
        justify="center"
        style={{ textAlign: "center", marginBottom: "200px", marginTop: "200px" }}
      >
        <Row>
          <Col xs={12}>
            <h3>
              Our order form is temporarily unavailable, we apologise for any inconvenience this may cause. We hope to have it up and running again soon.
              In the meantime, please email <Link
                to="mailto:{email}"
                style={{ textDecorationLine: "none" }}
              >{email}</Link>
            </h3>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return '';
  }

  
};

export default AlertMessage;
